//Competences table
const CompItem = [
  {
    id: '1',
    title: 'HTML5',
    icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968267.png',
    iconAlt: 'Icône HTML',
    rating: 5
  },
  {
    id: '2',
    title: 'CSS3',
    icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968242.png',
    iconAlt: 'Icône CSS',
    rating: 5
  },
  {
    id: '3',
    title: 'JavaScript',
    icon: 'https://cdn-icons-png.flaticon.com/512/919/919828.png',
    iconAlt: 'Icône JavaScript',
    rating: 4
  },
  {
    id: '4',
    title: 'React.js',
    icon:
      'https://styles.redditmedia.com/t5_2su6s/styles/communityIcon_4g1uo0kd87c61.png',
    iconAlt: 'Icône React.js',
    rating: 4
  },
  {
    id: '5',
    title: 'Sass',
    icon: 'https://www.iconbolt.com/iconsets/ionicons-logos/sass.svg',
    iconAlt: 'Icône Sass',
    rating: 5
  },
  {
    id: '6',
    title: 'Figma',
    icon: 'https://cdn-icons-png.flaticon.com/512/5968/5968701.png',
    iconAlt: 'Icône Figma',
    rating: 3
  },
  {
    id: '7',
    title: 'Node.JS',
    icon: 'https://cdn.iconscout.com/icon/free/png-256/nodejs-2-226035.png',
    iconAlt: 'Icône Node.JS',
    rating: 3
  },
  {
    id: '8',
    title: 'MongoDB',
    icon:
      'https://trainings.nicolasfazio.ch/wp-content/uploads/2020/04/d234566e9d.png',
    iconAlt: 'Icône MongoDB',
    rating: 3
  },
  {
    id: '9',
    title: 'JsonWebToken',
    icon:
      'https://media.licdn.com/dms/image/D4D12AQHW9aRSWIOMxQ/article-cover_image-shrink_600_2000/0/1657421703592?e=2147483647&v=beta&t=nKygyfSDFwgPdEoC-nEkogMS0527SBa8z8D_FqUr-us',
    iconAlt: 'Icône JWT',
    rating: 4
  },
  {
    id: '10',
    title: 'MySQL',
    icon:
      'https://www.freepnglogos.com/uploads/logo-mysql-png/logo-mysql-mysql-logo-png-images-are-download-crazypng-21.png',
    iconAlt: 'Icône MySQL',
    rating: 4
  }
]

export default CompItem
